const template = `
<div class="bottom-info">
	<div class="locked-overlay" data-locked-overlay></div>

	<div class="header">
		<div class="tab"><span class="title"></span></div>
		<div class="info-label"></div>
		<div class="align y"><div>
			<div class="info-items">
				<div class="info-item colored-border" data-sticky-template="bottom-info-header-info-item">
					<span class="label"></span>
					<span class="value"></span>
				</div>
			</div>
		</div></div>
	</div>

	<div class="content"></div>

</div>
`;

export default template;
